<template>
  <DragDialog
    title="导入"
    :width="572"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
    class="dialog-primary-light">
    <div class="tip-content-box">
      <div>注：</div>
      <!--prettier-ignore-->
      <div class="text-indent">(1) 请按模板内规则填写信息，若存在不符合的规则项，可能造成导入失败。</div>
      <!--prettier-ignore-->
      <div class="text-indent">(2) 确保所有名称都是唯一的，对于系统已存在的名称，系统将跳过不做处理。</div>
      <!--prettier-ignore-->
      <div class="text-indent">(3) 详情可下载<span class="link" @click="downloadTemplate"> 模板文件 </span>进行查看填写。</div>
    </div>

    <div class="read-file-box">
      <input
        ref="fileReader"
        type="file"
        name="file"
        class="input-file"
        accept=".txt"
        @change="handleFileChange" />

      <div class="file-name-box">
        <div class="file-name">
          <span v-if="fileName">{{ fileName }}</span>
          <span
            v-else
            class="placeholder-box">
            请选择文件
          </span>
        </div>
        <el-button
          size="small"
          class="file-upload-btn"
          @click="handleBtnClick">
          <span>上传文件</span>
        </el-button>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { importDataDictionaryService } from '@/service/dataDictionary'

export default {
  data() {
    return {
      fileName: '',
      nameList: []
    }
  },
  props: {
    visible: Boolean,
    currCatalog: Object
  },
  components: {
    DragDialog
  },
  mounted() {
    this.reader = new FileReader()
    this.reader.addEventListener('load', this.onReaderLoad)
  },
  destroyed() {
    this.reader.removeEventListener('load', this.onReaderLoad)
    this.reader = null
  },
  methods: {
    downloadTemplate() {
      let { origin, pathname } = window.location
      let documentPath = `${origin}${pathname.split('/index.html')[0]}`
      const templateUrl = `${documentPath}/document/模板.txt`

      const a = document.createElement('a')
      a.href = templateUrl
      a.download = '模板.txt' // 指定下载文件名
      a.click()
    },
    handleBtnClick() {
      let domRef = this.$refs.fileReader
      domRef.click()
    },
    handleFileChange() {
      let domRef = this.$refs.fileReader
      let files = domRef.files
      const file = files[0]

      if (!file) {
        this.$message.error('请选择文件')
        return
      }

      if (!this.isValidFileType(file)) {
        // prettier-ignore
        this.$message.error("导入失败，该文件格式错误(仅支持txt格式文件)");
        return
      }

      this.reader.readAsText(file)
    },
    onReaderLoad(e) {
      try {
        let domRef = this.$refs.fileReader
        let files = domRef.files
        const fileInfo = files[0]
        this.fileName = fileInfo.name

        const content = e.target.result
        const lines = content.split(/\r\n|\r|\n/)

        let nameList = []
        for (let line of lines) {
          if (line.trim().includes('*****')) break
          if (line.trim()) {
            nameList.push(line.trim())
          }
        }
        this.nameList = nameList

        domRef.value = ''
      } catch (error) {
        let domRef = this.$refs.fileReader
        domRef.value = ''

        console.log(error.message)
        this.$message.error('读取文件时出错')
      }
    },
    isValidFileType(fileInfo) {
      let fileName = fileInfo.name
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      const validFileTypes = ['txt']

      let isValid = true
      if (!validFileTypes.includes(fileType)) {
        isValid = false
      }

      return isValid
    },
    async submit() {
      let params = { typeId: this.currCatalog.id, nameList: this.nameList }
      let response = await importDataDictionaryService(params)
      if (response.isSuccess) {
        this.$emit('refreshDictionaryList')
        this.$message.success('导入成功')
        this.cancel()
      } else {
        this.$message.error(response.errMsg)
      }
    },
    cancel() {
      this.$emit('closeDialog')
      this.fileName = ''
      this.nameList = []
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-primary-light {
  :deep(.dialog-content) {
    padding: 16px 48px;
  }
}

.tip-content-box {
  font-size: 12px;
  color: var(--page-tips-text-color);
  font-weight: 400;
  line-height: 20px;

  .text-indent {
    text-indent: 10px;
  }

  .link {
    color: var(--base-bg-light-color50);
    text-decoration: underline;
    cursor: pointer;
  }
}

.read-file-box {
  position: relative;
  height: 100%;
  margin-right: 10px;
  overflow: hidden;
  margin-top: 16px;
  //   cursor: pointer;

  .file-name-box {
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: 32px;

    .file-name {
      flex-grow: 1;
      height: 32px;
      line-height: 29px;
      font-size: 14px;
      padding: 0px 8px;
      color: var(--upload-file-text-color);
      background: var(--upload-bg-color);
      border-radius: 8px 8px 8px 8px;
      border: 1px solid var(--upload-file-border-color);

      .placeholder-box {
        color: var(--upload-placeholder-color);
      }
    }

    .file-upload-btn {
      position: relative;
      margin-right: 0px;
      border-radius: 4px;
      z-index: 1;
      font-size: 14px;
      color: var(--upload-btn-color);
      background: var(--upload-bg-color);
      border: 1px solid var(--upload-file-border-color);

      &:hover {
        color: var(--upload-file-hover-color);
        border-color: var(--upload-file-hover-border-color);
        background: var(--upload-btn-hover-color);
      }
    }
  }

  input[type='file'] {
    position: absolute; //设置为绝对定位，不会影响到其他元素
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    font-size: 0; // 防止cursor属性失效
    opacity: 0; //透明度为0
    filter: alpha(opacity=0);
    cursor: pointer;
    z-index: 0;
  }
}
</style>
